import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as actions from '../../store/actions/index';
import WizardButton from '../Wizard/WizardButton';
import Aux from '../../hoc/Aux';
import WizardProductSystemImageCard from '../Wizard/WizardProductSystemImageCard';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import Select from 'react-select'
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { ROUTES } from '../../routes';

const Documentations = (props) => {

  const { t } = useTranslation();
  const [buttons, setButtons] = useState([]);
  const { width } = useWindowDimensions();
  let history = useHistory();

  let documentationFileUserInfos = [];
  const loading = useSelector(state => state.inventory.loadingDocumentationFileUserInfos );
  const dispatch = useDispatch();

  const styleSelected = {
    fontSize: "1.0rem",
    fontWeight: "500",
    margin: "0 10px 10px 0",
    color: "#fff",
    backgroundColor: "#f69c00",
    pointerEvents: "default",
    outline: "none"
  }

  const styleNotSelected = {
    fontSize: "1.0rem",
    fontWeight: "500",
    margin: "0 10px 10px 0",
    color: "#212529",
    backgroundColor: "#fff",
    pointerEvents: "default",
    borderColor: "#ccc",
    outline: "none"
  }


  // select

  const [penetrationOptions, setPenetrationOptions] = useState([]);
  const [penetrationRawData, setPenetrationRawData] = useState([]);
  const [zulassung, setZulassung] = useState(null);
  const [filteredProductSystemIds, setFilteredProductSystemIds] = useState([]);

  const [selectedPenetration, setSelectedPenetration] = useState(null);
  const { control } = useForm();


  useEffect(() => {
     dispatch( actions.fetchFilteredPenetrationsDocuments()).then((res1) => {
        setPenetrationRawData(res1)
     });
  }, []);

  useEffect(() => {
    if (zulassung !== null) {

      dispatch( actions.fetchFilteredPenetrationsDocuments() ).then((res) => {
        const arr_penetrations = penetrationRawData.filter(x => x.type === 'p' && x.zulassung === zulassung).map( pen => {
          return {
            value: pen.id,
            label: t(pen.token)
          }
        }).sort((a, b) => a.label < b.label ? -1 : 1)

        const arr_insultations = penetrationRawData.filter(x => x.type === 'i' && x.zulassung === zulassung).map( pen => {
          return {
            value: pen.id,
            label: t(pen.token)
          }
        }).sort((a, b) => a.label < b.label ? -1 : 1)

        const grouped_options = [
          {
            label: t( 'wizard.steps.product_system.select_penetration.group.penetrations' ),
            options: arr_penetrations
          },
          {
            label: t( 'wizard.steps.product_system.select_penetration.group.insultations' ),
            options: arr_insultations
          }
        ]

        setPenetrationOptions(grouped_options);
      });
    }
  }, [zulassung]);

  const onChangePenetration = (e) => {
    setSelectedPenetration(e);
    if (e === null) {
      setFilteredProductSystemIds([])
    } else {
      dispatch( actions.fetchFilteredProductSystems(e.value)).then((res) => {
        setFilteredProductSystemIds(res)
      })
    }
  }



  const customSelectStyles = {
    groupHeading: () => ({
      color: "black",
      marginLeft: "10px",
      marginBottom: "10px",
      fontSize: "1.2em"
    }),

  }

  const onSelect = (id) => history.push(ROUTES.TO_DOCUMENTATION(id));

  useEffect(() => {
    dispatch( actions.fetchAllProductsystems() ).then((res) => setButtons(res));
  }, []);




  // Wie im Dashboard
  useEffect(() => {
    dispatch( actions.fetchAllDocumentationFileUserInfos() );
  }, []);

  const thisDocumentationFileUserInfos = useSelector(state => {
    return (productSystemId) => actions.getAllDocumentationFileUserInfos(state)
  });

  if ( !loading ) {
    documentationFileUserInfos = thisDocumentationFileUserInfos() || [];
  }
  // Wie im Dashboard (Ende)




  const checkForUpdates = (productSystemId) => {
    const ret = documentationFileUserInfos.find( (x) => x['product_system_id'] === productSystemId) || undefined
    return ret !== undefined
  }

  const productsystems = useSelector(state => actions.getReduxObjects(state.inventory.productSystems, buttons));

  const displayedProductSystems = (productsystems, zulassung, productSystemIds) => {
    if (zulassung !== null) {
      productsystems = productsystems.filter(x => x.zulassungstyp === zulassung && x.number_documents_downloads > 0 );
    }
    if (selectedPenetration != null) {
      return productsystems.filter(x => productSystemIds.includes(x.id) && x.number_documents_downloads > 0 );
    } else {
      return productsystems.filter(x => x.number_documents_downloads > 0 );
    }
  }

  const getImageUrl = (ps) => {
    let imageArray = ps.product_system_images.filter(function(element){ return element.usage === 'documentation' });
    let firstImage = (imageArray !== [])? imageArray[0] : undefined
    let image_url = (firstImage !== undefined)? firstImage.image_url : ""
    return image_url;
  }

  const selectZulassung = (z) => {
    if (productsystems !== null && productsystems.length > 0) {
      if (zulassung === z) {
        setZulassung(null);
        setSelectedPenetration(null);
      } else {
        setZulassung(z);
        setSelectedPenetration(null);
      }
    }
    return null;
  }

  return(

    <Aux>

    <div className="main-container">
       <div className="container" style={{paddingBottom: "20rem"}}>
          <div className="row justify-content-center">
             <div className="col-lg-12 col-xl-12">
                <div className="page-header">
                   <h1>{ t('documentations.headline') }</h1>
                   <p className="lead"></p>
                </div>

                <div className="row ">
                  <div className="col-lg-11 col-xl-10">
                    <div className="row">
                      <div className="col-12 col-md-10" style={{marginBottom: "20px"}}>

                      <button
                        type="button"
                        className={"btn wizzard-nav-btn button-select-documentation"}
                        onClick={() => selectZulassung('abg')}
                        style={ (zulassung === 'abg')? styleSelected : styleNotSelected}
                        >{ t( 'documents.choice_zulassung.deutschland' ) }</button>

                        <button
                          type="button"
                          className={"btn wizzard-nav-btn button-select-documentation"}
                          onClick={() => selectZulassung('eta')}
                          style={ (zulassung === 'eta')? styleSelected : styleNotSelected}
                          >{ t( 'documents.choice_zulassung.europa' ) }</button>

                        { (zulassung !== null)?
                          <Controller
                             control={control}
                             name="penetrations"
                             defaultValue={selectedPenetration}
                             render= {({value, ref}) => (
                             <Select
                               noOptionsMessage={() => t( 'wizard.steps.product_system.select_penetration.no_result' ) }
                               isClearable={true}
                               styles={customSelectStyles}
                               placeholder={ t( 'wizard.steps.product_system.select_penetration.placeholder' ) }
                               options={penetrationOptions}
                               value={selectedPenetration}
                               onChange={ (e) => onChangePenetration(e) }
                               inputRef={ref}
                             />
                             )}
                           /> : null }
                      </div>
                    </div>
                  </div>
                </div>

                {(width < 1024)?
                  <div className="row">
                    <div className="col-lg-11 col-xl-10">
                      <div className="row">
                        { displayedProductSystems(productsystems, zulassung, filteredProductSystemIds).map( (x) => <WizardButton key={x.id} value={x.id} title={x.title} onClick={onSelect} dividerEnabled={false} /> ) }
                      </div>
                    </div>
                  </div>
                :
                  <div className="row">

                      <div className="col-lg-12 col-xl-12">
                            <div className="container-fluid" style={{padding: "0px"}} >
                                <div className="row col-centered">
                                  { displayedProductSystems(productsystems, zulassung, filteredProductSystemIds).map( (x) => { return (<WizardProductSystemImageCard
                                                          hasUpdates={checkForUpdates(x.id)}
                                                          key={x.id}
                                                          value={x.id}
                                                          title={x.title}
                                                          featureList={[]}
                                                          imageUrl={getImageUrl(x)}
                                                          onClick={onSelect}
                                                          dividerEnabled={false} />)}
                                                         )
                                  }
                                </div>
                            </div>
                      </div>

                  </div>
                }

            </div>
          </div>
        </div>
      </div>
    </Aux>
 );
};

export default Documentations;



// WEBPACK FOOTER //
// ./src/components/Documentations/Documentations.js